import React from 'react';

import cn from '@/utils/cn';

import { toneText, toneTint } from './tone';
import { UnrecognizedStyle } from './types';

interface Props {
  coverage: number;
  unrecognized: UnrecognizedStyle[];
}

// How much of the compared print text uses paragraph styles the tool understands. Every
// unrecognized style is concrete feedback for the InDesign author (the authoring contract).
const StyleCoverage = ({ coverage, unrecognized }: Props) => {
  const pct = Math.round(coverage * 1000) / 10;

  return (
    <div className="tw-mt-3">
      <div className="tw-flex tw-items-center tw-gap-3">
        <div className="tw-h-2 tw-flex-1 tw-overflow-hidden tw-rounded-full tw-bg-spa-bg-tertiary">
          <div className="tw-h-full tw-bg-spa-success" style={{ width: `${pct}%` }} />
        </div>
        <span className="tw-text-sm tw-font-bold tw-tabular-nums tw-text-spa-heading">{pct}%</span>
      </div>

      {unrecognized.length === 0 ? (
        <p className={cn('tw-m-0 tw-mt-2 tw-text-sm', toneText.success)}>
          Every paragraph in the compared stories uses a recognized style.
        </p>
      ) : (
        <ul className="tw-mt-2 tw-flex tw-list-none tw-flex-col tw-gap-2 tw-p-0">
          {unrecognized.map(item => (
            <li key={`${item.style}-${item.storyTitle}`} className={cn('tw-rounded tw-px-3 tw-py-2', toneTint.warning)}>
              <span className={cn('tw-font-mono tw-text-sm tw-font-bold', toneText.warning)}>
                {item.style}
              </span>
              <span className="tw-text-sm tw-text-spa-secondary">
                {' '}— {item.paragraphs} paragraph{item.paragraphs === 1 ? '' : 's'} in “{item.storyTitle}”,
                treated as body text. Ask layout to apply a standard text style.
              </span>
              <p className="tw-m-0 tw-mt-0.5 tw-text-xs tw-italic tw-text-spa-secondary">“{item.sample}”</p>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default StyleCoverage;
